import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import '@shui/core/sh-access-bar';
import '@shui/core/sh-tabs';

@Component({
  selector: 'app-navigation-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './navigation-header.component.html',
  styleUrl: './navigation-header.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NavigationHeaderComponent {
  @Output() tabChange = new EventEmitter<number>();
  
  activeTab = 0;
  tabs = [
    { tabName: 'Search', isActive: true },
    { tabName: 'SPC', isActive: false }
  ];

  onTabClicked(index: number): void {
    this.activeTab = index;
    this.tabs.forEach((tab, i) => {
      tab.isActive = i === index;
    });
    this.tabChange.emit(index);
  }
}
